import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#000000', // Customize the primary color
    },
    secondary: {
      main: '#2196f3', // Customize the secondary color
    },
    // You can customize other colors like error, warning, info, etc.
  },
  // You can also customize typography, spacing, and other theme properties here
});

export default customTheme;